import React from "react";

/**
 * Simple controlled field component used in edit forms.
 * Calls onChange(value) — the plain value string, not the event.
 */
const Field = ({
  label,
  type = "text",
  value,
  onChange,
  full = false,
  placeholder = "",
}) => (
  <div className={`smField${full ? " smFieldFull" : ""}`}>
    <label className="FP_Content_Semibold">{label}</label>
    {type === "textarea" ? (
      <textarea
        className="smFieldInput"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={3}
      />
    ) : (
      <input
        className="smFieldInput"
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    )}
  </div>
);

export default Field;
